import type {
	CreateSensorRequest,
	Sensor,
	UpdateSensorRequest,
} from "@sitescene/types";

import { apiClient } from "../client";
import { ENDPOINTS } from "../endpoints";

/**
 * Shadow Realm sensors API (org via `X-Shadow-Org` on the client).
 */
export const sensorsApi = {
	createSensor: async (body: CreateSensorRequest): Promise<Sensor> => {
		const response = await apiClient.post<Sensor>(
			ENDPOINTS.shadow.sensors.create,
			body,
		);
		return response.data;
	},

	updateSensor: async (
		sensorId: string,
		body: UpdateSensorRequest,
	): Promise<Sensor> => {
		const response = await apiClient.put<Sensor>(
			ENDPOINTS.shadow.sensors.update(sensorId),
			body,
		);
		return response.data;
	},
};
